import { useState, useEffect, useCallback } from "react";
import { FaSearch, FaRegTrashAlt, FaEdit, FaPlus } from 'react-icons/fa';
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import DataTable from 'react-data-table-component';
import '../common/style.css';
import './payment.css';
import { useLocation} from 'react-router-dom';
import {  showPaymentByAccountID, deletePaymentByID } from "../http/api"; // Assume this API returns payment data
import Loading from "../loading/loading";
import AddPaymentForm from './editPayment'; // Form component for add/edit
import { Modal} from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ShowPayment() {
    const [loading, setLoading] = useState(true);
    const [accountName, setAccountName] = useState();
    const [accountId, setAccountId] = useState(null)
    const location = useLocation();

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const [payments, setPayments] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredPayments, setFilteredPayments] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [currentPayment, setCurrentPayment] = useState(null);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    

    const handleDelete = (paymentId) => {
        setAccountToDelete(paymentId);
        setShowDeleteModal(true); // Show the delete confirmation modal
    };
    

    const [paymentToDelete, setAccountToDelete] = useState(null);

    const handleDeleteConfirm = () => {
        if (paymentToDelete) {
            deletePaymentByID(paymentToDelete) // Updated to use deleteSarfaesiDataByID
                .then((response) => {
                    if (response.status === 200 || response.status === 204) {

                        // Update the payments state instead of users
                        setPayments(prevPayments => prevPayments.filter(payment => payment.id !== paymentToDelete));
                        setShowDeleteModal(false);
                        toast.success("Payment transaction has been deleted successfully!", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            style: {
                                border: "3px solid green",
                                borderRadius: "8px",
                                padding: "10px",
                                bottom: "-45px",
                            }
                        });
                    } else {
                        toast.error("Failed to delete account. Please try again.", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            style: {
                                border: "3px solid red",
                                borderRadius: "8px",
                                padding: "10px",
                                bottom: "-45px",
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error deleting account:", error);
                    toast.error("Failed to delete account. Please try again.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            border: "3px solid red",
                            borderRadius: "8px",
                            padding: "10px",
                            bottom: "-45px",
                        }
                    });
                });
        }
    };

    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    
    useEffect(() => {
        const filtered = payments.filter(payment => {
            // Check status text using getStatus
            const statusText = getStatus(payment).text.toLowerCase();
    
            // Match search term with any field or the derived status text
            return Object.values(payment).some(value =>
                typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
            ) || statusText.includes(searchTerm.toLowerCase());
        });
    
        setFilteredPayments(filtered);
    }, [searchTerm, payments]);
    

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleEdit = (payment) => {
        setCurrentPayment(payment);
        setShowModal(true);
    };

    const handleAdd = () => {
        setCurrentPayment(null);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setCurrentPayment(null);
    };

    const updatePaymentInList = (updatedPayment) => {
        setPayments(prevPayments =>
            prevPayments.map(p =>
                p.id === updatedPayment.id ? updatedPayment : p
            )
        );
    };

    const addPaymentToList = (newPayment) => {
        setPayments(prevPayments => [newPayment, ...prevPayments]);
        setSearchTerm('');
    };

    // const conditionalRowStyles = [
    //     {
    //         when: (row) => row.dueAmount > 0, // Condition: Due amount greater than 0
    //         style: {
    //             backgroundColor: "rgba(255, 0, 0, 0.2)", // Light red background
    //             color: "red", // Optional: Change text color
    //         },
    //     },
    // ];


    useEffect(() => {
        if (location.state && location.state.accountDetails) {
            const newAccountId = location.state.accountDetails.id;
            const newAccountName = location.state.accountDetails.accountName;

            if (newAccountId && newAccountId !== accountId) {  // Check if accountId changed
                setAccountId(newAccountId);  // Update state with new accountId
                setAccountName(`Payment - ${newAccountName}`);  // Update account name
            }
        }
    }, [location.state, accountId]);  // Depend only on location.state and accountId

    const viewPayment = useCallback((accountId) => {
        setLoading(true);
        showPaymentByAccountID(accountId)
            .then(response => {
                if (response.status === 200) {
                    const accountData = response.data.map(item => ({
                        id: item.id,
                        invoiceNo: item.invoiceNo,
                        invoiceDate: item.invoiceDate,
                        invoiceAmount: item.invoiceAmount,
                        dueDate: item.dueDate,
                        paymentReceived: item.paymentReceived,
                        tdsReceived: item.tdsReceived,
                        paymentReceivedDate: item.paymentReceivedDate,
                        paymentMethod: item.paymentMethod,
                        remark: item.remark
                    }));
                    setPayments(accountData);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error fetching payment details:', error);
            });
    }, []);

    useEffect(() => {
        if (accountId !== null) {  // Ensure we only call viewPayment when accountId is valid
            viewPayment(accountId);
        }
    }, [accountId, viewPayment]);  // Depend only on accountId

    const formatDate = (date) => {
        if (!date) return ''; // Return empty string if no date is provided
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = String(d.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    };
    
    const getStatus = (row) => {
        const currentDate = new Date();
        const dueDate = new Date(row.dueDate);
    
        // Calculate the difference in days between the due date and the current date
        const daysDifference = (currentDate - dueDate) / (1000 * 60 * 60 * 24);
    
        console.log("daysDifference:", daysDifference);

          // Check if fully paid
        if (Number(row.paymentReceived) + Number(row.tdsReceived) >= row.invoiceAmount) {
            return { text: 'Paid', color: 'green', bgColor: '#d4edda' }; // Green background for Paid
        }
    
        // Check overdue or due within specific ranges
        if (daysDifference > 0 && daysDifference <= 7) {
            // Due within a week
            return { text: 'Due (within a week)', bgColor: '#fff3cd' }; // Yellow background
        } else if (daysDifference > 7) {
            // Due within a month but more than a week
            return { text: 'Due (more than a week)', bgColor: '#ffe5b4' }; // Orange background
        } else {
            return { text: 'Due', bgColor: '#ffffff' }; // Blue background for future due
        }
    };
    
    
    // Define the columns
    const columns = [
        {
            name: 'Status',
            selector: (row) => getStatus(row).text, 
            cell: (row) => {
                const status = getStatus(row);
                return (
                    <span style={{ color: status.color, fontWeight: 'bold' }}>
                        {status.text}
                    </span>
                );
            },
            sortable: true,
        },
        { name: 'Invoice No', selector: row => row.invoiceNo, sortable: true },
        { name: 'Invoice Date', selector: row => formatDate(row.invoiceDate), sortable: true },
        { name: 'Due Date', selector: row => formatDate(row.dueDate), sortable: true },
        { name: 'Invoice Amount', selector: row => row.invoiceAmount, sortable: true },
        { name: 'Payment Method', selector: row => row.paymentMethod, sortable: true },
        { name: 'TDS Amount Received', selector: row => row.tdsReceived, sortable: true },
        { name: 'Payment Received', selector: row => row.paymentReceived || 0, sortable: true },
        { name: 'Payment Received Date', selector: row => formatDate(row.paymentReceivedDate), sortable: true },
        { name: 'Remark', selector: row => row.remark, sortable: true },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <button
                        onClick={() => handleEdit(row)}
                        className="btn btn-sm btn-primary me-1"
                        title="Edit Bank"
                    >
                        <FaEdit />
                    </button>
                    <button
                        onClick={() => handleDelete(row.id)}
                        className="btn btn-sm btn-danger"
                        title="Delete Bank"
                    >
                        <FaRegTrashAlt />
                    </button>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    
    // Define conditional row styles
    const conditionalRowStyles = [
        {
            when: (row) => getStatus(row).text === 'Paid',
            style: {
                backgroundColor: '#d4edda', // Green background for Paid
            },
        },
        {
            when: (row) => getStatus(row).text === 'Due (within a week)',
            style: {
                backgroundColor: '#fff3cd', // Yellow background for Due within a week
            },
        },
        {
            when: (row) => getStatus(row).text === 'Due (more than a week)',
            style: {
                backgroundColor: '#f8d7da', // Red background for Due more than a week
            },
        },
        {
            when: (row) => getStatus(row).text === 'Due',
            style: {
                backgroundColor: '#ffffff', // Orange background for Default Due
            },
        },
    ];
    
    
    useEffect(() => {
        console.log('location.state ' + location.state);

        if (location.state?.success) {
            toast.success("Payment transaction has been submitted successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                    border: "3px solid green",
                    borderRadius: "8px",
                    padding: "10px",
                    bottom: "-45px",
                }
            });
        }
    }, [location.state]);

    return (
        <div className="ShowPayments">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNave isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">{accountName}</h4>
                                <hr className="bg-warning" style={{ height: '4px' }} />
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <button className="btn btn-sm btn-warning" onClick={handleAdd}>
                                            <FaPlus /> Add Payment
                                        </button>
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                className="form-control me-2"
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                            <button className="btn btn-sm btn-secondary">
                                                <FaSearch />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mb-4">
                                    <div className="card-body shadow-sm border-0">
                                        <DataTable
                                            columns={columns}
                                            data={filteredPayments}
                                            conditionalRowStyles={conditionalRowStyles}
                                            pagination
                                            highlightOnHover
                                        />
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>

             {/* Delete Confirmation Modal */}
             {showDeleteModal && (
                <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowDeleteModal(false)}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Deletion</h5>
                            </div>
                            <div className="modal-body">
                                Are you sure you want to delete this account?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-danger" onClick={handleDeleteConfirm}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <Modal show={showModal} onHide={handleModalClose} dialogClassName="modal-lg">
                <Modal.Header closeButton>
                    <Modal.Title>{currentPayment ? 'Edit Payment' : 'Add Payment'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddPaymentForm
                        formData={currentPayment}
                        closeModal={handleModalClose}
                        updatePaymentInList={updatePaymentInList}
                        addPaymentToList={addPaymentToList}
                        accountId={accountId}
                    />
                </Modal.Body>
            </Modal>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
